import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { DATE_FORMAT_CLIENT_PARAMS, DATE_TIME_FORMAT_CLIENT, ROLES } from '../../helpers/constants'
import { useTranslation } from 'react-i18next'
import { Button, Space } from 'antd'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
// @ts-ignore
import ReactExport from 'react-data-export'
import moment from 'moment'
import { useRef, useState } from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import * as XLSX from 'xlsx'
import { cloneDeep, groupBy, isEmpty, isError, reduce, set } from 'lodash'
import PreviewFileImport from './PreviewFileImport'
import { OrdersStore } from 'src/stores/OrdersStore'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const ExportToCSV = observer((props: any) => {
   const { from: fromDate, to: toDate, getData } = props
   const { t } = useTranslation()
   const AuthStore = useStore('AuthStore')
   const { data_getUserInfo } = AuthStore
   const ProductStore = useStore('ProductStore')

   const exportRef = useRef(null)
   const inputFileRef = useRef(null)
   const [visiblePreviewImport, setVisiblePreviewImport] = useState(false)
   const [selectedRow, setSelectedRow] = useState<any[]>([])
   const [dataInsert, setDataInsert] = useState<any>(null)

   const [rows, setRows] = useState<any[]>([])

   const handleInputFile = () => {
      if (inputFileRef.current !== null) {
         // @ts-ignore
         inputFileRef.current!.click()
      }
   }

   const handleImportCSV = async (event: any) => {
      const file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = async (e: any) => {
         const data = new Uint8Array(e.target.result)
         const workbook = XLSX.read(data, { type: 'array' })
         const sheetName = workbook.SheetNames[0]
         const rawWorksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
            header: [
               'name',
               'images',
               'tags',
               'sellerIDs',
               'description',
               'weigh',
               'baseCost',
               'shippingFee',
               'packingFee',
               'handingFee',
               'labelFee'
            ],
            raw: false,
            defval: ''
         })

         // Xử lý từng dòng để thay thế null/undefined bằng chuỗi rỗng
         const worksheet = rawWorksheet.map((row: any) => {
            const processedRow = {} as any
            Object.keys(row).forEach((key) => {
               processedRow[key] = row[key] === null || row[key] === undefined ? '' : row[key]
            })
            return processedRow
         })
         worksheet.splice(0, 1) // Xóa dòng tiêu đề nếu có
         // setSelectedRow(cloneDeep(worksheet))
         console.log('====================================')
         console.log('dataRows', worksheet)
         console.log('====================================')
         const dataImport = worksheet.map((item: any) => {
            return {
               ...item,
               images: item.images ? item.images.split(',') : [],
               tags: item.tags ? item.tags.split(',') : [],
               sellerIDs: item.sellerIDs ? item.sellerIDs.split(',') : []
            }
         })

         setDataInsert(cloneDeep(dataImport))
         setVisiblePreviewImport(true)

         const dataResponse = await ProductStore.previewListProduct(cloneDeep(dataImport))

         if (dataResponse?.code == 200) {
            // dataRows = dataRows.map((row: any) => {
            //    const found = dataResponse.data.find((d: any) => d.sellerOrderId == row.sellerOrderId)
            //    if (found && found?.isError) {
            //       return {
            //          ...row,
            //          isError: true,
            //          errorMessage: found.errorMessage
            //       }
            //    }
            //    return row
            // })
            setSelectedRow(dataResponse?.data)
         }

         setVisiblePreviewImport(true)

         // OrdersStore.setOrderList(worksheet)
      }
      reader.readAsArrayBuffer(file)
   }

   const handleExportData = async () => {
      try {
         const dataResponse = await ProductStore.getDataAllProduct()
         console.log('dataResponse', dataResponse)

         if (isEmpty(dataResponse)) {
            return
         }

         setRows(dataResponse || [])

         if (exportRef.current !== null) {
            // @ts-ignore
            exportRef.current!.click()
         }
      } catch (error) {}
   }

   const exportToCSV = () => {
      return (
         <ExcelFile
            element={
               <Button ref={exportRef}>
                  {t(GLOBAL_CLIENT.exportCSV)}
                  <DownloadOutlined />
               </Button>
            }
            filename={`Đơn đặt hàng ${moment().format('HH:mm:ss DD-MM-YYYY')}`}
         >
            <ExcelSheet com data={rows} name="PurchaseOrderManagement">
               <ExcelColumn label={'Id'} value="id" />
               <ExcelColumn label={'name'} value="name" />
               <ExcelColumn
                  label={'Ngày tạo'}
                  value={(col: any) => moment(col?.createdAt).format(DATE_TIME_FORMAT_CLIENT)}
               />
               <ExcelColumn
                  label={'Ngày cập nhật'}
                  value={(col: any) => moment(col?.updatedAt).format(DATE_TIME_FORMAT_CLIENT)}
               />
               <ExcelColumn
                  label={'Ảnh'}
                  value={(col: any) => {
                     return (col?.images || []).map((po: any) => po).join(', ')
                  }}
               />
               <ExcelColumn label={'Giá Bán'} value={(col: any) => col?.priceDefault?.baseCost || '0'} />
               <ExcelColumn label={'Giá ship'} value={(col: any) => col?.priceDefault?.shippingFee || '0'} />
               <ExcelColumn
                  label={'Trạng thái'}
                  value={(col: any) => t(col?.status ? GLOBAL_CLIENT.active : GLOBAL_CLIENT.inactive)}
               />
               <ExcelColumn
                  label={'tags'}
                  value={(col: any) => {
                     return (col?.tagDetails || []).map((tag: any) => tag?.name).join(', ')
                  }}
               />
               <ExcelColumn
                  label={'Dành cho bạn'}
                  value={(col: any) =>
                     isEmpty(col?.sellerDetails)
                        ? 'Tất cả'
                        : (col?.sellerDetails || []).map((acc: any) => `${acc?.name} - ${acc?.email} `).join(', ') ||
                          '0'
                  }
               />
            </ExcelSheet>
         </ExcelFile>
      )
   }

   return (
      <Space>
         {data_getUserInfo?.role == ROLES.ADMIN && (
            <Button className="btn-add" onClick={handleInputFile}>
               {'Nhập Excel'}
            </Button>
         )}

         {data_getUserInfo?.role == ROLES.ADMIN && (
            <Button onClick={handleExportData}>
               {t(GLOBAL_CLIENT.exportExcel)}
               <DownloadOutlined />
            </Button>
         )}

         <div style={{ display: 'none' }}>
            <input ref={inputFileRef} type="file" accept=".xlsx, .xls" onChange={handleImportCSV} />
            {exportToCSV()}
         </div>

         {visiblePreviewImport && (
            <PreviewFileImport
               items={selectedRow}
               visible={visiblePreviewImport}
               onOk={() => {
                  setVisiblePreviewImport(false)
                  if (inputFileRef.current) {
                     ;(inputFileRef.current as HTMLInputElement).value = ''
                  }
                  getData?.()
               }}
               onCancel={() => {
                  setVisiblePreviewImport(false)
                  if (inputFileRef.current) {
                     ;(inputFileRef.current as HTMLInputElement).value = ''
                  }
               }}
               dataInsert={dataInsert}
            />
         )}
      </Space>
   )
})

export default ExportToCSV
